import { Box } from '@mui/system';
import type { IconSvgProps } from './Icon';

type BaseLibraryIconSvgProps = IconSvgProps;

export default function BaseLibraryIconSvg({
  name,
  color,
  width = 24,
  height: _height,
  children,
  classname,
  viewBox = '0 0 24 24',
  ...svgProps
}: BaseLibraryIconSvgProps) {
  return (
    <Box
      component='svg'
      viewBox={viewBox}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      sx={{ width, height: 'auto', color, flexShrink: '0' }}
      className={classname}
      data-testid={name}
      {...svgProps}
    >
      {children}
    </Box>
  );
}
